import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import {bindActionCreators} from 'redux';
import EventSummary from '../components/EventSummary';
import { getMainEvent } from '../selectors/event';

class EventSummaryContainer extends Component {
    render() {
        return(
            <EventSummary
                locale={this.props.locale}
                name={this.props.name}
                start={this.props.start}
                end={this.props.end}
                venueName={this.props.venue ? this.props.venue.name : ""}
                venueAddress={this.props.venue ? this.props.venue.address.city + ', ' + this.props.venue.address.region : ""}
                image={this.props.image}
                uiConfig={this.props.uiConfig}
                childEvent={this.props.childEvent}
                isRecurring={this.props.isRecurring}
                ages={this.props.ages}
                hideAgeLimit={this.props.hideAgeLimit}
            />
        )
    }
}

const mapStateToProps = (state, props) => {
    const defaultEvent = getMainEvent(state)?.event ?? null;
    const defaultVenue = Object.values(state.venue.venues).length
        ? Object.values(state.venue.venues)[0]
        : null;
    let event = props.event ? props.event : defaultEvent;
    let venue = props.venue ? props.venue : defaultVenue;

    // @todo hack for now -- need better resolve data loading for listing information
    if(venue?.loading) {
        venue = null;
    }

    return {
        locale: state.intl.locale,
        name: event?.name ?? '',
        start: event?.start ?? '',
        end: event?.end ?? '',
        image: event?.image ?? '',
        ages: event?.age_minimum,
        hideAgeLimit: event?.hide_age_limit,
        venue: venue,
        uiConfig: state.ui.uiConfig,
        childEvent: (state.event.childEvent) ? state.event.childEvent : null,
        isRecurring: state.ui.isRecurring,
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({

    }, dispatch);
}

EventSummaryContainer.propTypes = {
    locale: PropTypes.string.isRequired,
    name: PropTypes.string,
    start: PropTypes.string,
    venueName: PropTypes.object,
    image: PropTypes.node, // not sure if this is the right proptype for image
}

export default connect(mapStateToProps, mapDispatchToProps)(EventSummaryContainer)
